/**
 * The nudge's length cap, mirrored from the proxy's `lib/nudgeMessage.js`.
 *
 * A `maxLength` on the textarea is a courtesy, not the guard: the proxy slices to the same number
 * whatever arrives. Duplicated as a constant rather than fetched because a number the server
 * enforces anyway is not worth a round trip — but if one moves, move both.
 */
export const MAX_NUDGE_CHARS = 2000;
